module.exports = __webpack_public_path__ + "img/pfander.15f24740.jpg";